
<section class="container-fluid mt-5 nopadd">
    <div class="row">
        <div class="col-12 nopadd">
    <h2 class="tituloEventos">Todos los eventos de este promotor</h2>
    <div *ngIf ='message' class="alert alert-success ">{{message}}</div>
    <div class="container-fluid nopadd">
    <table class="table mt-3 contenedorLista">

        <thead>
            <tr>
                <th>PullEp</th>
                <th>Nombre</th>
                <th>Fecha</th>
                <th>Organizador</th>
                <th>Eliminar evento del promotor</th>
                
            </tr>
        </thead>
        <tbody>
          
            <tr *ngFor = "let evento of eventosPromotor" class="filasEventos">
                <td>{{evento?.id}}</td>
                <td>{{evento?.nombre }}</td>
                <td>{{evento?.fecha| date}}</td>
                <td>{{evento.organizadorid}}</td>
                <td><button class="btn btn-danger" (click)="eliminar(evento.id)">Eliminar</button></td>
    
            </tr>
    
    
        </tbody>
    
    </table>
</div>

</div>
</div>

</section>


<section class="container-fluid mt-5 nopadd">
    <div class="row">
        <div class="col-12 nopadd">
    <h2 class="tituloEventos">Todos los eventos en general</h2>
    <div *ngIf ='message' class="alert alert-success ">{{message}}</div>
    <div class="container-fluid nopadd">
    <table class="table mt-3 contenedorLista">

        <thead>
            <tr>
                <th>PullEp</th>
                <th>Nombre</th>
                <th>Fecha</th>
                <th>Organizador</th>
                <th>Agregar promotor al evento</th>
    
                
            </tr>
        </thead>
        <tbody>
          
            <tr *ngFor = "let evento of eventos" class="filasEventos">
                <td>{{evento?.id}}</td>
                <td>{{evento?.nombre }}</td>
                <td>{{evento?.fecha| date}}</td>
                <td>{{evento.organizadorid}}</td>
                <td><button class="btn btn-warning" (click)="agregar(evento?.id)">Agregar</button></td>
    
            </tr>
    
    
        </tbody>
    
    </table>
</div>

</div>
</div>

</section>